import React, { JSX } from "react";
import { Typography } from "./ui/typography";
import { Info } from "lucide-react";
import clsx from "clsx";

interface TransactionDetailRowProps {
  label: string;
  value: string | React.ReactNode | JSX.Element;
  showInfo?: boolean;
  valueClassName?: string;
  isBold?: boolean;
}

export const TransactionDetailRow: React.FC<TransactionDetailRowProps> = ({
  label,
  value,
  showInfo = false,
  valueClassName,
  isBold = false,
}) => {
  return (
    <div className="p-4 flex justify-between items-center">
      <Typography className="flex items-center gap-1 text-sm text-text-secondary">
        {label}
        {showInfo && <Info size={14} className="text-text-secondary" />}
      </Typography>
      <Typography
        className={clsx(
          "text-sm text-text-primary",
          isBold ? "font-bold" : "font-medium",
          valueClassName
        )}
      >
        {value}
      </Typography>
    </div>
  );
};
